import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/sharp-regular-svg-icons";

interface PillRadioButtonProps extends Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  "type" | "children"
> {
  children: string;
  selected?: boolean;
  iconType?: "positive" | "negative";
}

export function PillRadioButton({
  children,
  selected = false,
  iconType = "positive",
  className,
  ...props
}: PillRadioButtonProps) {
  const icon = iconType === "positive" ? faCheck : faXmark;

  return (
    <button
      {...props}
      type="button"
      className={`
        w-full h-20 flex items-center gap-4 px-3 py-3 rounded-full
        border cursor-pointer font-medium text-left transition-all duration-200
        ${
          selected
            ? "bg-[#252423] text-white border-[#252423]"
            : "bg-white text-[#252423] border-[rgba(204,197,194,0.5)] hover:border-[#252423]"
        }
        ${className || ""}
      `}
      name={children}
    >
      <div
        className={`
          w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0
          ${selected ? "bg-[#efff92]" : "bg-[#cfd7df]"}
        `}
      >
        <FontAwesomeIcon icon={icon} className="w-5 h-5 text-[#252423]" />
      </div>
      <div className="flex-1">
        <div className="text-base leading-6 font-medium">{children}</div>
      </div>
    </button>
  );
}
